import { IAction } from '../../../../../__core/Interfaces/IAction';
import { shareExamsInProgressInitState } from './InitState';
import SHARING_ACTIONS from '../Actions/ActionTypes';

export const shareExamsInProgressReducer = (
  state: Array<number> = shareExamsInProgressInitState,
  action: IAction<number>
): Array<number> => {
  switch (action.type) {
    case SHARING_ACTIONS.SHARE_EXAMS_FOR_STUDENT_START:
      return [...state, action.payload];

    case SHARING_ACTIONS.SHARE_EXAMS_FOR_STUDENT_FINISH:
      return [...state.filter((value) => value !== action.payload)];

    default:
      return state;
  }
};
